import { render, staticRenderFns } from "./CreateBankAccountsPage.vue?vue&type=template&id=6a0b8be2&"
import script from "./CreateBankAccountsPage.vue?vue&type=script&lang=js&"
export * from "./CreateBankAccountsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports